import { AxiosResponse } from 'axios';
import { ApiBase, ApiResponse, EStoreProduct } from 'types';

const BASE_URL = 'product';

export interface ProductVariantOption {
  id: number;
  value: string;
  stock?: number;
}

export interface VariantWithOptions {
  id: number;
  name: string;
  options: ProductVariantOption[];
}

export interface SaveProductRequest {
  id?: number;
  price: number;
  name: string;
  title: string;
  description?: string;
  isActive: boolean;
  photoUrls: string[];
  variantOptions: {
    variantOptionId: number;
    stockQuantity: number;
  }[];
  expertisePointGroupType?: number;
}

export class ProductApi extends ApiBase {
  public async getVariantWithOptions(): Promise<ApiResponse<VariantWithOptions[]>> {
    const response: AxiosResponse<ApiResponse<VariantWithOptions[]>> = await this.apiClient.get(
      `${BASE_URL}/variant-with-options`,
    );
    return response.data;
  }

  public async saveProduct(request: SaveProductRequest): Promise<ApiResponse<number>> {
    const response: AxiosResponse<ApiResponse<number>> = await this.apiClient.post(`${BASE_URL}/save`, request);
    return response.data;
  }

  public async removeProduct(id: number): Promise<ApiResponse<void>> {
    const response: AxiosResponse<ApiResponse<void>> = await this.apiClient.delete(`${BASE_URL}/remove/${id}`);
    return response.data;
  }

  // e-magaza
  public async getCanBeOrderedProducts(): Promise<ApiResponse<EStoreProduct[]>> {
    const response = await this.apiClient.get(`${BASE_URL}/get-can-be-ordered-products`);
    return response.data;
  }

  public async searchProducts(queryParams?: string): Promise<ApiResponse<EStoreProduct[]>> {
    const url = queryParams ? `${BASE_URL}/search?${queryParams}` : `${BASE_URL}/search`;

    const response: AxiosResponse<ApiResponse<any[]>> = await this.apiClient.get(url);
    return response.data;
  }

  public async uploadPhoto(file: File): Promise<ApiResponse<string>> {
    const formData = new FormData();
    formData.append('file', file);

    const response: AxiosResponse<ApiResponse<string>> = await this.apiClient.post(
      `${BASE_URL}/upload-photo`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    return response.data;
  }
}
